import React from "react";
import Experience from "../Items/Experience";

const experiencesData = [
  {
    id: 1,
    year: "2023 - Present",
    degree: "DevOps Training & Freelance Work",
    content:
      "After completing military service, I started professional training in Linux, networking, and DevOps tools such as Docker, Kubernetes, CI/CD, and monitoring tools like Grafana and Prometheus. I also worked on hands-on projects involving Elasticsearch, Kibana, and Python scripting.",
  },
  {
    id: 2,
    year: "2020 - 2023",
    degree: "IT Specialist at Idigi",
    content:
      "Worked as a WordPress Administrator in the IT department of Idigi, managing website updates, plugins, and server maintenance. This role helped me develop a deeper understanding of IT infrastructure and web management.",
  },
  {
    id: 3,
    year: "2018 - 2020",
    degree: "System Administrator",
    content:
      "Joined a company specializing in VPN and Apple ID services, where I gained experience as a System Administrator. This sparked my interest in computer science and system operations.",
  },
  {
    id: 4,
    year: "2015 - 2018",
    degree: "Bachelor’s Degree in Accounting At Karaj Azad Univercity",
    content:
      "Earned a bachelor's from Karaj Azad Univercity degree in Accounting, providing me with a strong foundation in analysis and problem-solving, which later proved valuable in my IT career.",
  },
  {
    id: 5,
    year: "2013 - 2015",
    degree: "First Job in Mobile Sales",
    content:
      "Started my professional journey in mobile sales, which developed my communication skills and taught me the importance of technology in daily life.",
  },
];

function Experiences() {
  return (
    <div className="timeline">
      {experiencesData.map((experience) => (
        <Experience experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default Experiences;
